import { AnyAction } from 'redux';
import { RootState } from '../reducers';
import { AuthState } from './interfaces';

export const getUser = (state: RootState): AppConfig.User => state.Auth.user;
export const getUserId = (state: RootState): AppConfig.User['id'] => state.Auth.user.id;
export const getUserIsFromWKD = (state: RootState): AppConfig.User['isWkd'] => state.Auth.user.isWkd;
export const getActionAccumulator = (state: RootState): AnyAction[] => state.Auth.actionAccumulator;
export const getRefreshingTokenInProgress = (state: RootState): AuthState['refreshingTokenInProgress'] =>
  state.Auth.refreshingTokenInProgress;
export const getParentUser = (state: RootState): AppConfig.User | null => state.Auth.parent;
export const getParentUserId = (state: RootState): AppConfig.User['id'] | undefined => state.Auth.parent?.id;
